export default class Calendar {
    constructor(options) {
        this.options = options;
        this.today = new Date();
        this.currentEventDates = [];
        this.eventDates = [];
        this.eventData = [];
        this.year = this.today.getFullYear();
        this.month = this.today.getMonth();
        this.monthLabels = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
        this.days = document.getElementsByClassName('day-cell');
        this.daysLen = this.days.length;
        this.setDate;

        this.draw();
    }

    /**
     * Initial draw of the calendar
     */
    draw() {
        this.getOptions();
        this.drawHeader();
        this.drawDays();

        // Add click functions
        let prev = document.getElementsByClassName('prev-button'),
            next = document.getElementsByClassName('next-button');

        prev[0].addEventListener('click', () => this.prevMonth());
        next[0].addEventListener('click', () => this.nextMonth());

        for (let i = 0; i < this.daysLen; i++) {
            this.days[i].addEventListener('click', (event) => this.clickDay(event.target));
        }
    }

    /**
     * Update the calendar header
     */
    drawHeader() {
        // Set header month text
        let headMonth = document.getElementsByClassName('head-month');
        headMonth[0].innerHTML = this.monthLabels[this.month] + ' ' + this.year;

        // Set prev and next month labels
        document.getElementsByClassName('prev-month')[0].innerHTML = this.monthLabels[(this.month - 1 + this.monthLabels.length) % this.monthLabels.length];
        document.getElementsByClassName('next-month')[0].innerHTML = this.monthLabels[(this.month + 1) % this.monthLabels.length];
    }

    /**
     * Update the calendar days table
     */
    drawDays() {
        let startDay = new Date(this.year, this.month, 1).getDay(),

            // The following indicates the total number of days in the month
            numberOfDays = new Date(this.year, this.month + 1, 0).getDate(),
            n = startDay;

        // Set monday as the first day of the week
        n = (n === 0) ? 6 : n - 1;

        // Clear original style and date
        for (let k = 0; k < 42; k++) {
            this.days[k].innerHTML = '';
            this.days[k].className = 'day-cell';
            delete this.days[k].dataset.calendarDate;
            delete this.days[k].dataset.calendarModalData
            this.days[k].dataset.bsToggle = '';
            this.days[k].dataset.bsPlacement = '';
            this.days[k].dataset.bsHtml = 'false';
            this.days[k].dataset.bsTitle = '';
        }

        // Add dates as content
        for (let i = 1; i <= numberOfDays; i++) {
            this.days[n].innerHTML = i;
            this.days[n].dataset.calendarDate = this.year + '-' + String(this.month + 1).padStart(2, '0') + '-' + String(i).padStart(2, '0');
            n++;
        }

        // Draw all possible day cells
        for (let j = 0; j < 42; j++) {

            // Disabled if there is no content
            if (this.days[j].innerHTML === '') {
                this.days[j].classList.add('day-disabled');
            }

            // Date string of the current day in iteration
            let dayDateString = this.days[j].dataset.calendarDate;

            // Add today class
            let yearToday = this.today.getFullYear();
            let monthToday = (this.today.getMonth() + 1).toString().padStart(2, '0');  // Months are zero-based, so add 1
            let dayToday = this.today.getDate().toString().padStart(2, '0');
            let todayFormatted = `${yearToday}-${monthToday}-${dayToday}`;
            if (dayDateString === todayFormatted) {
                this.days[j].classList.add('day-today');
            }

            // Mark current event
            if (this.currentEventDates && this.currentEventDates.includes(dayDateString)) {
                this.days[j].classList.add('day-has-event');
                this.days[j].classList.add('day-current');
            }

            // Mark all events
            if (this.eventDates && this.eventDates.includes(dayDateString)) {
                this.days[j].classList.add('day-has-event');
            }

            // Add event data to cells
            if (typeof this.eventData === 'object' && this.eventData.hasOwnProperty(dayDateString)) {
                this.days[j].dataset.calendarModalData = JSON.stringify(this.eventData[dayDateString]);

                // Add tooltips
                this.days[j].dataset.bsToggle = 'tooltip';
                this.days[j].dataset.bsPlacement = 'bottom';
                this.days[j].dataset.bsHtml = 'true';
                // Implode event titles
                this.days[j].dataset.bsTitle = this.eventData[dayDateString].map(event => event.title).join('<br>-<br>');
            }
        }

        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }

    /**
     * Load previous month
     */
    prevMonth() {
        if (this.month === 0) {
            this.month = 11;
            this.year--;
        } else {
            this.month--;
        }
        this.drawHeader();
        this.drawDays();
    }

    /**
     * Load next month
     */
    nextMonth() {
        if (this.month === 11) {
            this.month = 0;
            this.year++;
        } else {
            this.month++;
        }
        this.drawHeader();
        this.drawDays();
    }

    /**
     * Click on a day
     *
     * @param dayElement
     */
    clickDay(dayElement) {

        if (!dayElement.dataset.calendarModalData) {
            return;
        }

        // Get the clicked date
        let dayDate = new Date(dayElement.dataset.calendarDate);

        // Generate modal title
        document.getElementById('calendarModalLabel').innerText
            = dayDate.getFullYear() + '. ' + this.monthLabels[dayDate.getMonth()] + ' ' + dayDate.getDate() + '.';

        // Generate modal body
        let body = JSON.parse(dayElement.dataset.calendarModalData);
        let listHtml = '<ul class="list-group list-group-flush">';
        body.forEach(item => {
            listHtml += `<li class="list-group-item"><a href="${item.url}" class="btn btn-primary fw-bold text-white rounded-0 w-100">${item.title}</a></li>`;
        });
        listHtml += '</ul>';
        document.getElementById('calendarModalBody').innerHTML = listHtml;

        // Open modal
        let calendarModal = new bootstrap.Modal(document.getElementById('calendarModal'), {
            keyboard: false
        });
        calendarModal.show();
    }

    /**
     * Parse initial options
     */
    getOptions() {

        if (this.options) {

            // Dates for the current event
            this.currentEventDates = this.options.currentEventDates ?? false;

            // The current event date to set
            if (this.currentEventDates && this.options.currentEventDates.length > 0) {
                this.setDate = new Date(this.options.currentEventDates[0]);
            } else {
                this.setDate = this.today;
            }

            // All event dates
            this.eventDates = this.options.eventDates ?? false;

            // All event data
            this.eventData = this.options.eventData ?? false;

            this.year = this.setDate.getFullYear();
            this.month = this.setDate.getMonth();
        }
    }
}
//
// // Initializing the Calendar with default options
// new Calendar({
//     eventDates       : ['2024-09-01', '2024-09-02', '2024-09-28', '2024-09-29', '2024-09-30'],
//     currentEventDates: ['2024-09-25', '2024-09-26'],
// });